import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function AdministrarPlantillas() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    let userdata = [];
    let clientData = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log('err: '+error);
            });
    },[]);

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key={'k1'}><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key={'k2'}><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key={'k3'}>Administrar Plantillas</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Administrar Plantillas</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            
                            <div className="row">
                                <div className="col-md-12 btn-settings-container">
                                    
                                    <Link to="/parametros-evolucion" className="btn-settings">
                                    Parámetros en Evolución
                                    </Link>

                                    {/* COMENTADO: Parámetros Historia Clínica - Ya no se usa, se gestiona desde superadmin */}
                                    {/* <Link to="/parametros-historia-clinica" className="btn-settings">
                                    Parámetros Historia Clínica
                                    </Link> */}

                                    <Link to="/plantillas-formulas" className="btn-settings">
                                    Fórmulas Médicas
                                    </Link>

                                    <Link to="/plantillas-examenes" className="btn-settings">
                                    Exámenes de Laboratorio
                                    </Link>

                                    <Link to="/plantillas-recomendaciones" className="btn-settings">
                                    Recomendaciones
                                    </Link>

                                    <Link to="/plantillas-incapacidades" className="btn-settings">
                                    Incapacidades y Certificados
                                    </Link>

                                    <Link to="/plantillas-eventos-adversos" className="btn-settings">
                                    Eventos Adversos
                                    </Link>

                                    <Link to="/plantillas-consentimientos" className="btn-settings">
                                    Consentimientos Informados
                                    </Link>

                                    <Link to="/otras-plantillas" className="btn-settings">
                                    Otras Plantillas
                                    </Link>

                                    <Link to="/plantillas-historia-clinica-json" className="btn-settings">
                                    Administrar Historias Clínicas
                                    </Link>

                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default AdministrarPlantillas;